import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';
import storeWorkingSpace from "@/module/store/workingspace";
import {CONFIG_ENV} from '@/config';
import {I_Gift} from "@/types/iGift";
import EditGiftForList from "@/components/EditGiftForList/EditGiftForList";
import {displayLink} from "@/module/utils";

interface I_GiftForIdeas{
    giftid:number,
    gift_name:string,
    url_for_img:string,
    gift_url_host:string
}

interface I_AjaxResponse_AddGift{
    status:number,
    statusText:string,
    data: {
        status:string,
        message:string,
        giftid:number
    }
}

@Component({components:{ EditGiftForList}})
export default class GiftIdeas extends Vue {
    myBoolTrue:boolean=true;
    myBoolFalse:boolean=false;
    ajaxIsRunning:boolean=false;
    firstListFormAutoPlaySlider:string='first';
    last50GiftIdeas:Array<I_GiftForIdeas>=[];
    nr_of_visible_images:number=0;
    isVisibleCardOpenGift:boolean=false;
    dialogAddChildToList:boolean=false;
    currentChildComponent:string='';
    childid_for_edit:number=0;
    giftToOpen:I_GiftForIdeas={
        giftid:0,
        gift_name:'',
        url_for_img:'',
        gift_url_host:''
    };
    stars:number=3;
    private storeWorkingSpace=getModule(storeWorkingSpace);
    $refs:any;
    constructor(){
        super();
        if(this.$q.platform.is.desktop) {this.nr_of_visible_images=5;} else{this.nr_of_visible_images=3;}
    }

    async loadLast50GiftLists(){
        const vueInst=this;
        let res = await axios.get(`${CONFIG_ENV.URL_PUBLIC_INFO.get_last50_public_gift_ideas}`);
        let data = await res.data;
        vueInst.last50GiftIdeas=[];
        if(res.data.status=='success'){
            res.data.gifts.forEach((pgift:I_GiftForIdeas)=>{
                    vueInst.last50GiftIdeas.push({
                        giftid:pgift.giftid,
                        gift_name:pgift.gift_name,
                        url_for_img:CONFIG_ENV.URL_PUBLIC_INFO.getImageAsAvatarForGift+'/'+pgift.giftid,
                        gift_url_host:pgift.gift_url_host
                    });
            });

        }
    }

    goToPrevSlide(){
        this.$refs.mycarouselGifts.goPrev();
    }
    goToNextSlide(){
        this.$refs.mycarouselGifts.goNext();
    }

    openGiftShortDetails(pgift:I_GiftForIdeas){
        const vueInst=this;
        vueInst.isVisibleCardOpenGift=true;
        vueInst.giftToOpen.giftid=pgift.giftid;
        vueInst.giftToOpen.gift_name=pgift.gift_name;
        vueInst.giftToOpen.gift_url_host=pgift.gift_url_host;
        vueInst.giftToOpen.url_for_img=pgift.url_for_img;
    }

    displayLink50Chr(pstr:string):string{
        return displayLink(pstr);
    }

    async addGiftToMyList() {
        const vueInst = this;
        if (vueInst.giftToOpen.giftid * 1 == 0) {
            var res = await <Promise<I_AjaxResponse_AddGift>>axios.post(`${CONFIG_ENV.URL_GIFTS.add_giftid_from_suggestions_to_list}/${storeWorkingSpace.state.listid}/${vueInst.giftToOpen.giftid}`);
        }
    }

    fctInParentforActionInGift(info_from_child_comanda:string) {
        var vueInst = this;
        switch (info_from_child_comanda){
            case 'GIFT_SAVED':
                                vueInst.dialogAddChildToList=false;
                                vueInst.isVisibleCardOpenGift=false;
                                vueInst.currentChildComponent='';
                                vueInst.$emit('infofromchildCommand', 'GIFT_SAVED');
                                break;
        }
    }

    tryToAddGiftToMyList(){
            const vueInst=this;
        this.dialogAddChildToList=true;
        this.currentChildComponent='EditGiftForList';
    }

    get listid():number{
        const vueInst=this;
        return vueInst.storeWorkingSpace.listid;
    }

    get listName():string{
        const vueInst=this;
        return vueInst.storeWorkingSpace.list_name;
    }
    activated(){
        const vueInst=this;
        vueInst.last50GiftIdeas=[];
        vueInst.loadLast50GiftLists();
    }

    created() {
        var vueInst = this;
        //@ts-ignore
        vueInst.$eventHub.$on('infofromchildCommand', (params: any) => {
            vueInst.dialogAddChildToList=false;
            vueInst.isVisibleCardOpenGift=false;
            vueInst.currentChildComponent='';
        });
    }

    beforeDestroy() {
        //@ts-ignore
        this.$eventHub.$off('infofromchildCommand');
    }
}
